var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Country"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.68232 15.5989H7.22564C6.50072 15.5989 5.80265 15.317 5.2791 14.7935L0.553698 10.0681C0.526849 10.3768 0.5 10.699 0.5 11.0212C0.513424 16.7266 4.88979 21.4923 10.5818 21.9621V16.5118C10.5952 16.0151 10.179 15.5989 9.68232 15.5989Z",
    fill: "#57E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.2405 3.20819L17.6028 4.84597C17.1732 5.27555 16.5959 5.51719 15.9784 5.51719H14.7165C14.4614 5.51719 14.2601 5.71856 14.2601 5.97363V6.88649C14.2601 8.14838 13.2398 9.18207 11.9645 9.18207C11.7094 9.18207 11.5081 9.39686 11.5081 9.6385V10.0949C11.5081 10.6051 11.9242 11.0078 12.4209 11.0078H15.1729C16.6899 11.0078 17.9249 12.2428 17.9249 13.7598V14.6458C17.9249 14.7666 17.9786 14.8875 18.0592 14.968L20.4622 17.371C23.59 12.9946 23.0665 6.99388 19.2405 3.20819Z",
    fill: "#57E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.0859 14.6458V13.7598C16.0859 13.2497 15.6697 12.8469 15.173 12.8469H12.421C10.9041 12.8469 9.66901 11.6119 9.66901 10.0949V9.63848C9.66901 8.37658 10.6893 7.3429 11.9646 7.3429C12.2196 7.3429 12.421 7.14153 12.421 6.88647V5.98703C12.421 4.72513 13.4413 3.69145 14.7166 3.69145H15.9785C16.0993 3.69145 16.2201 3.63775 16.3007 3.55721L17.8176 2.04025C12.8774 -1.46353 6.03098 -0.282182 2.54063 4.67144C1.84256 5.65142 1.31901 6.7388 0.969971 7.8933L6.58139 13.5047C6.7559 13.6792 6.98412 13.7732 7.22576 13.7732H9.66901C11.186 13.7732 12.421 15.0083 12.421 16.5252V21.9755C15.0119 21.7607 17.4418 20.6331 19.2809 18.7939L16.7571 16.2702C16.3275 15.8406 16.0859 15.2499 16.0859 14.6458Z",
    fill: "#57E7C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.432a0d5d3461f0d2666f1bd2faae5067.svg";
export { ForwardRef as ReactComponent };